import React, { useState } from 'react';
import styles from './TemplateHeader.module.css';

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { BrowserRoutes } from '../../constants/BrowserRoutes';

import { useContext } from 'react';
import ThemeContext from '../../contexts/ThemeContext';
import HeadPhoneSvg from './HeadPhoneSvg';
import MobileNavButton from '../MobileNavButton/MobileNavButton';
import {
  BusinessLogo,
  ContentContainer,
} from '@pfstechnology/pfs-templates-core';

const StyledNavLink = (props) => {
  const theme = useContext(ThemeContext);
  const { pathname } = useLocation();
  const color =
    pathname === BrowserRoutes.HOME ? theme.whiteColor : theme.blackColor;

  const textStyle = {
    color,
    borderColor: color,
    fontFamily: props.fontFamily ?? theme.secondaryFont,
  };

  return (
    <NavLink style={textStyle} className={props.className ?? ''} to={props.to}>
      {props.children}
    </NavLink>
  );
};

const NavItems = () => {
  const theme = useContext(ThemeContext);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const headPhoneColor =
    pathname === BrowserRoutes.HOME ? theme.whiteColor : theme.blackColor;
  const buttonStyle = {
    backgroundColor: theme.secondaryColor,
    color: theme.blackColor,
    fontFamily: theme.secondaryFont,
  };

  return (
    <>
      <ul>
        <li>
          <StyledNavLink to={BrowserRoutes.HOME}>Home</StyledNavLink>
        </li>
        <li>
          <StyledNavLink to={BrowserRoutes.MENU}>Menu</StyledNavLink>
        </li>
      </ul>
      <ul>
        <StyledNavLink
          className={styles.phoneNumber}
          to={`tel:${theme.phoneNumber}`}
        >
          <HeadPhoneSvg fill={headPhoneColor} />
          {theme.phoneNumber}
        </StyledNavLink>
        <button onClick={() => navigate(`${BrowserRoutes.HOME}#contact`)} style={buttonStyle}>Contact Us</button>
      </ul>
    </>
  );
};

const TemplateHeader = () => {
  const theme = useContext(ThemeContext);
  const { pathname } = useLocation();
  const backgroundColor =
    pathname === BrowserRoutes.HOME ? theme.primaryColor : 'white';
  const logo =
    pathname === BrowserRoutes.HOME ? theme.whiteLogo : theme.coloredLogo;

  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };
  const classes = `${styles.MobileNav} ${open ? '' : styles.isHidden}`;

  return (
    <div style={{ backgroundColor }}>
      <ContentContainer width={90}>
        <nav className={styles.Nav} data-testid="TemplateHeader">
          <StyledNavLink
            to={BrowserRoutes.HOME}
            className={styles.logo}
            fontFamily={theme.primaryFont}
          >
            <BusinessLogo img={logo} size={300} />
            {theme.headerTitle}
          </StyledNavLink>
          <div className={styles.DesktopNav}>
            <NavItems />
          </div>
          <MobileNavButton open={open} handleToggle={handleToggle} />
        </nav>
      </ContentContainer>
      <div
        style={{ backgroundColor }}
        data-testid="MobileNavPanel"
        className={classes}
        onClick={(e) => {
          if (e.target !== e.currentTarget) {
            handleToggle();
          }
        }}
      >
        <NavItems />
      </div>
    </div>
  );
};

export default TemplateHeader;
